"use client";

import Script from "next/script";
import { usePathname } from "next/navigation";

import { logError } from "@/services/DatadogService/DatadogService";
import { PATHS } from "@/internals/constants/paths";

interface AmplitudeWebExperimentsProps {
  amplitudeApiKey: string;
}

const PRICING_PATH_PATTERN = new RegExp(`^(/[^/]+)?${PATHS.PRICING}/?$`);

/**
 * Pricing resolves the experiment variant from a cookie right after hydration, so
 * the script cannot wait for idle time there; elsewhere it stays deferred.
 */
export const resolveAmplitudeScriptStrategy = (pathname?: string | null) =>
  pathname && PRICING_PATH_PATTERN.test(pathname) ? "afterInteractive" : "lazyOnload";

export const AmplitudeWebExperiments = ({ amplitudeApiKey }: AmplitudeWebExperimentsProps) => {
  const pathname = usePathname();

  return (
    <Script
      id="amplitude-web-experiment"
      crossOrigin="anonymous"
      strategy={resolveAmplitudeScriptStrategy(pathname)}
      src={`https://cdn.eu.amplitude.com/script/${amplitudeApiKey}.experiment.js`}
      onError={(e) => {
        logError(new Error("Amplitude Web Experiments script failed to load"), {
          context: "AmplitudeWebExperiments",
          details: e,
        });
      }}
    />
  );
};
